import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";
import ExportButton from "../2/Controls/ExportButton";
import { exportFile } from "../../actions/DataExporter";

class LowStockReport extends Component {

  constructor(props) {

    super(props);

    this.state = {

      // DATA
      masterList: [],
      filteredList: [],
      list: [],

      totalCount: 0,
      loading: false,

      // PAGINATION
      page: 1,
      pageSize: 25,

      // SEARCH
      searchParam: "",

      // FILTER
      filter: {
        storeIds: []
      },

      stores: [],

      showFilter: false,
      showOption: false,

      isFilterActive: false,

      listPageSettings: {

        Title: "Low Stock",

        Search: {

          showSearch: true,
          placeholder: "Search product by SKU, barcode or name",

          onSearch: this.onSearch,

          onRefresh: this.onRefreshClick,

          onFilterClick: () =>
            this.setState({ showFilter: true }),

          isFilterActive: false

        },

        HeaderButtons: [
          { ButtonType: "ImageButton", Type: "option", Text: "Options", Icon: "option", Action: "options" }
        ],

        RowButtons: [],

        Columns: [
          {
            Name: "Store",
            Type: "field",
            Columns: [
              { Column: "StoreName" }
            ]
          },

          {
            Name: "Name",
            Type: "field",
            Columns: [
              { Column: "ProductName" }
            ]
          },

          {
            Name: "Code",
            Type: "multiple",
            Columns: [
              { Column: "ProductSKU" },
              { Column: "BarCode" }
            ]
          },







          {
            Name: "Retail Price",
            Type: "field",
            Columns: [
              {
                Column: "RetailPrice",
                Type: "number"
              }
            ]
          },

          {
            Name: "MRP",
            Type: "field",
            Columns: [
              {
                Column: "MRP",
                Type: "number"
              }
            ]
          },
          {
            Name: "InStock Qty",
            Type: "field",
            Columns: [
              {
                Column: "InStockQty",
                Type: "number"
              }
            ]
          },
          {
            Name: "DRR",
            Type: "field",
            Columns: [
              {
                Column: "DRR",
                Type: "number"
              }
            ]
          },

          {
            Name: "ReOrder Qty",
            Type: "field",
            Columns: [
              {
                Column: "ReOrderQty",
                Type: "number"
              }
            ]
          },
          {
            Name: "Loss Qty",
            Type: "field",
            Columns: [
              {
                Column: "LossQty",
                Type: "number"
              }
            ]
          },



        ]

      }

    };

  }

  componentDidMount() {

    const defaultStoreIds = [
      this.props.user.store.key
    ];

    this.setState(
      {
        filter: {
          storeIds: defaultStoreIds
        },
        stores: this.props.config.UserStores || []
      },
      () => {

        this.loadData();

      }
    );

  }

  loadData = async () => {

    this.setState({ loading: true });

    try {

      const { filter } = this.state;

      // PASS ARRAY
      const res =
        await this.props.getLowStockData(
          filter.storeIds
        );

      const masterList =
        res.lossData || [];

      this.setState(
        {
          masterList,
          filteredList: masterList,
          loading: false
        },
        () => {

          this.applyFrontendFilter();

        }
      );

    }

    catch (error) {

      console.error(error);

      this.setState({
        loading: false
      });

    }

  };

  applyFrontendFilter = () => {

    const {
      masterList,
      searchParam,
      page,
      pageSize
    } = this.state;

    let filteredList = [...masterList];

    // SEARCH
    if (searchParam) {

      const text =
        searchParam.toLowerCase();

      filteredList =
        filteredList.filter(item => {

          return (

            (item.ProductName || "")
              .toLowerCase()
              .includes(text)

            ||

            (item.ProductSKU || "")
              .toLowerCase()
              .includes(text)

            ||

            (item.BarCode || "")
              .toLowerCase()
              .includes(text)

          );

        });

    }

    // PAGINATION
    const start =
      (page - 1) * pageSize;

    const end =
      start + pageSize;

    const paginatedList =
      filteredList.slice(start, end);

    this.setState({

      filteredList,
      list: paginatedList,
      totalCount: filteredList.length

    });

  };

  // SEARCH
  onSearch = (text) => {

    this.setState(
      {
        searchParam: text,
        page: 1
      },
      () => {

        this.applyFrontendFilter();

      }
    );

  };

  // REFRESH
  onRefreshClick = () => {

    this.setState(
      {
        searchParam: "",
        page: 1,
        isFilterActive: false
      },
      () => {

        this.applyFrontendFilter();

      }
    );

  };

  // PAGINATION
  onPageChange = (page, pageSize) => {

    this.setState(
      {
        page,
        pageSize
      },
      () => {

        this.applyFrontendFilter();

      }
    );

  };

  onNextClick = () => {

    const totalPages =
      Math.ceil(
        this.state.totalCount /
        this.state.pageSize
      );

    if (this.state.page < totalPages) {

      this.setState(
        {
          page: this.state.page + 1
        },
        () => {

          this.applyFrontendFilter();

        }
      );

    }

  };

  onPreviousClick = () => {

    if (this.state.page > 1) {

      this.setState(
        {
          page: this.state.page - 1
        },
        () => {

          this.applyFrontendFilter();

        }
      );

    }

  };

  onFirstClick = () => {

    this.setState(
      {
        page: 1
      },
      () => {

        this.applyFrontendFilter();

      }
    );

  };

  onLastClick = () => {

    const totalPages =
      Math.ceil(
        this.state.totalCount /
        this.state.pageSize
      );

    this.setState(
      {
        page: totalPages
      },
      () => {

        this.applyFrontendFilter();

      }
    );

  };

  onRecordsPerPageCountChange = (size) => {

    this.setState(
      {
        pageSize: Number(size),
        page: 1
      },
      () => {

        this.applyFrontendFilter();

      }
    );

  };

  // FILTER
  onApplyFilter = () => {

    this.setState(
      {
        page: 1,
        showFilter: false,
        isFilterActive: true
      },
      () => {

        this.loadData();

      }
    );

  };

  onClearFilter = () => {

    this.setState(
      {
        filter: {
          storeIds: [
            this.props.user.store.key
          ]
        },
        page: 1,
        showFilter: false,
        isFilterActive: false,
        searchParam: ""
      },
      () => {

        this.loadData();

      }
    );

  };


  onHeaderButtonClicked = (btn) => {
    if (btn.Action === "options") {

      this.setState({ showOption: true });

    }

  };

 handleExport = async (type) => {

  const exportColumns = [
    { header: "Store", field: "StoreName" },
    { header: "Name", field: "ProductName" },
    { header: "SKU", field: "ProductSKU" },
    { header: "BarCode", field: "BarCode" },
    { header: "Retail Price", field: "RetailPrice" },
    { header: "MRP", field: "MRP" },
    { header: "InStock Qty", field: "InStockQty" },
    { header: "DRR", field: "DRR" },
    { header: "ReOrder Qty", field: "ReOrderQty" },
    { header: "Loss Qty", field: "LossQty" }
  ];

  try {

    // EXPORT FULL FILTERED DATA
    let data = this.state.filteredList || [];

    if (data.length > 0) {

      await exportFile({
        data: data,
        columns: exportColumns,
        fileType: type,
        title: "Low Stock Report",
        landscape: true
      });

    } else {

      this.setState({
        showExportMessage: true,
        exportMessage: "No data available to export"
      });

    }

  } catch (error) {

    console.error(error);

    this.setState({
      showExportMessage: true,
      exportMessage: `Export failed: ${error.message}`
    });

  }

};
  render() {

    return (

      <>

        <ListingPage

          {...this.props}
          onClose={() =>
            this.props.history.goBack()
          }

          listPageSettings={{

            ...this.state.listPageSettings,

            Search: {

              ...this.state.listPageSettings.Search,

              isFilterActive:
                this.state.isFilterActive

            }

          }}

          list={this.state.list}

          loading={this.state.loading}

          totalItemsCount={
            this.state.totalCount
          }

          recordFrom={
            (this.state.page - 1) *
            this.state.pageSize
          }

          itemsCountPerPage={
            this.state.pageSize
          }

          onPageChange={
            this.onPageChange
          }

          onNextClick={
            this.onNextClick
          }

          onPreviousClick={
            this.onPreviousClick
          }

          onFirstClick={
            this.onFirstClick
          }

          onLastClick={
            this.onLastClick
          }

          onRecordsPerPageCountChange={
            this.onRecordsPerPageCountChange
          }

          onHeaderButtonClicked={this.onHeaderButtonClicked}
          searchText={
            this.state.searchParam
          }

        />

        {
          this.state.showFilter &&

          <Window

            header="Filter"

            size="small"

            slide

            onClose={() =>
              this.setState({
                showFilter: false
              })
            }

            onButtonClick={(action) => {

              if (
                action.toLowerCase() === "apply"
              ) {

                this.onApplyFilter();

              }

              else if (
                action.toLowerCase() === "clear"
              ) {

                this.onClearFilter();

              }

            }}

            buttons={[

              {
                Type: "secondary",
                Text: "Clear",
                Align: "left"
              },

              {
                Type: "primary",
                Text: "Apply",
                Align: "right"
              }

            ]}

          >

            <Input

              type="select"

              label="Store"

              value={
                this.state.filter.storeIds[0] || ""
              }

              onChange={(v) => {

                this.setState({

                  filter: {
                    ...this.state.filter,
                    storeIds: [v]
                  }

                });

              }}

            >

              {
                this.state.stores.map((s) => (

                  <option
                    key={s.key}
                    value={s.key}
                  >

                    {s.StoreCode} {s.StoreName}

                  </option>

                ))
              }

            </Input>

          </Window>

        }

        {
          this.state.showOption &&

          <Window

            header="Options" choiceList

            size="small"

            slide

            onClose={() =>
              this.setState({
                showOption: false
              })
            }

          >

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap"
              }}
            >
              <ExportButton
                onExport={(value) =>
                  this.handleExport(value)
                }
                loading={
                  this.state.loading
                }
              />

            </div>

          </Window>

        }

      </>

    );

  }

}

export default LowStockReport;